import { getProposalStatusAndCustomStatus } from "@/utils/getProposalStatusAndCustomStatus.ts";
import { Badge } from "@chakra-ui/react";

export enum ProposalStatus {
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  PENDING_FORMALIZATION = "PENDING_FORMALIZATION",
  PENDING_REFORMALIZATION = "PENDING_REFORMALIZATION",
  PENDING_BANK_ANALYSIS = "PENDING_BANK_ANALYSIS",
  PENDING_PAYMENT = "PENDING_PAYMENT",
  PENDING_USER_REVIEW = "PENDING_USER_REVIEW",
  SELFSERVICE = "SELFSERVICE",
  PAYED = "PAYED",
  CANCELED = "CANCELED",
  IN_CANCELLATION = "IN_CANCELLATION",
  CANCELED_BY_CLIENT = "CANCELED_BY_CLIENT",
  REPROVED = "REPROVED",
  ERROR_CREATE_BIOMETRIC_VALIDATION = "ERROR_CREATE_BIOMETRIC_VALIDATION",
}

interface StatusRendererProps {
  status: ProposalStatus;
  customStatus?: string | null | undefined
}

interface StatusMapProperties {
  color: string;
  text: string;
}
const statusMap: Record<ProposalStatus, StatusMapProperties> = {
  [ProposalStatus.PAYED]: {
    color: "green.500",
    text: "Pago",
  },
  [ProposalStatus.CANCELED]: {
    color: "red.500",
    text: "Cancelado",
  },
  [ProposalStatus.REPROVED]: {
    color: "red.500",
    text: "Reprovado",
  },
  [ProposalStatus.IN_CANCELLATION]: {
    color: "yellow.500",
    text: "Cancelamento em andamento",
  },
  [ProposalStatus.CANCELED_BY_CLIENT]: {
    color: "red.500",
    text: "Cancelado pelo cliente",
  },
  [ProposalStatus.SELFSERVICE]: {
    color: "secondary",
    text: "Self service",
  },
  [ProposalStatus.PENDING_CONFIRMATION]: {
    color: "green.500",
    text: "Aguardando Confirmação",
  },
  [ProposalStatus.PENDING_FORMALIZATION]: {
    color: "secondary",
    text: "Aguardando Formalização",
  },
  [ProposalStatus.PENDING_REFORMALIZATION]: {
    color: "yellow.500",
    text: "Aguardando Refazer Formalização",
  },
  [ProposalStatus.PENDING_BANK_ANALYSIS]: {
    color: "yellow.500",
    text: "Aguardando Análise Banco",
  },
  [ProposalStatus.PENDING_PAYMENT]: {
    color: "orange.500",
    text: "Aguardando Pagamento",
  },
  [ProposalStatus.PENDING_USER_REVIEW]: {
    color: "purple.500",
    text: "Erro na Criação da Proposta",
  },
  [ProposalStatus.ERROR_CREATE_BIOMETRIC_VALIDATION]: {
    color: "red.500",
    text: "Falha no Link da Formalização",
  },
};

export function getStatusProps(status: string): StatusMapProperties {
  return statusMap[ProposalStatus[status as keyof typeof ProposalStatus]];
}

export function StatusRenderer({ status, customStatus }: StatusRendererProps) {
  const { color = "gray.500", text = "Desconhecido" } = statusMap[status] || {};
  return (
    <Badge bg={color} color="white" mb={4} mt={2} px={3} py={1} display="flex" alignItems="center" justifyContent="center" fontSize="sm" fontWeight="bold" fontFamily="Lexend Deca" borderRadius="md">
      {getProposalStatusAndCustomStatus(status, customStatus!) || text}
    </Badge>
  );
}
